import React from "react";
import { get, isEmpty } from "lodash";
import styles from "../globalSearch.module.css";
import Highlights from "./Highlights";
import classNames from "classnames";
import formatDate from "helpers/formatDate";

type ArticleProps = {
  id: string;
  title: string;
  teaser?: string;
  published_at?: string;
  image_url: string;
  blog_id: string;
  blog_title: string;
  meta?: {
    highlight?: {
      title?: string[];
      teaser?: string[];
      body?: string[];
    };
  };
};

export default function ArticleHit({
  id,
  blog_id,
  title,
  teaser,
  blog_title,
  meta,
  published_at,
  image_url,
}: ArticleProps) {
  const teaserHighlights = get(meta, ["highlight", "teaser"]);
  const bodyHighlights = get(meta, ["highlight", "body"]);

  const allHighlights = [
    ...(teaserHighlights || []),
    ...(bodyHighlights || []),
  ];

  const articleUrl = `/blogs/${blog_id}/articles/${id}`;

  return (
    <div
      className={classNames("ArticleHit border-box py-2 clearfix", styles.hit)}
    >
      <div className="article-header px-3 flex items-center mb-2">
        <div className="activity-actor-image py-4 mr-4">
          <a className="member-link" href={articleUrl}>
            <img className="w-16 h-16" src={image_url} alt={title} />
          </a>
        </div>
        <div className="article-headline py-4 flex-1">
          <div className="article-meta">
            <div className={"flex flex-col"}>
              <span className="article-title font-semibold">
                <a href={articleUrl}>{title}</a>
              </span>
              <div>
                <a
                  className="font-semibold leading-none text-normal text-sm"
                  href={`/blogs/${blog_id}`}
                >
                  {blog_title}
                </a>
              </div>
              {published_at && (
                <a href={articleUrl} className="muted text-sm leading-none">
                  <time
                    className="published_at"
                    dateTime={published_at}
                    title={formatDate(new Date(published_at), "PPPP HH:mm")}
                  >
                    {formatDate(new Date(published_at), "PPPP HH:mm")}
                  </time>
                </a>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className={"flex flex-col p-3 gap-4"}>
        {teaser && (
          <div className={classNames("article-object", styles.hitContent)}>
            <div className="text-muted">{teaser}</div>
          </div>
        )}

        {!isEmpty(allHighlights) && (
          <div className="mt-2">
            <Highlights highlights={allHighlights} />
          </div>
        )}
      </div>
      <div className="border-neutral border-dashed border-t">
        <a className="btn btn-link block" href={articleUrl}>
          {I18n.t("js.global_search.articles.show_article")}
        </a>
      </div>
    </div>
  );
}
